// Hooks
//
const formHook = "[js-contact-form]";
const submitHook = "[js-contact-submit]";
const inputHook = "[js-contact-input]";
const innerHook = "[js-contact-inner]";
const titleHook = "[js-contact-title]";
const descriptionHook = "[js-contact-description]";
const emailErrorHook = "[js-contact-email-error]";

// Classes
//
const api = 'https://dk.wild-digital.com/wp/wp-content/themes/wild-theme/mail/send.php'

class Contact {
  constructor(element) {
    this.element = element;
    this.form = element.querySelector(formHook);
    this.submit = element.querySelector(submitHook);
    this.inputs = element.querySelectorAll(inputHook);
    this.inner = element.querySelector(innerHook);
    this.title = element.querySelector(titleHook);
    this.description = element.querySelector(descriptionHook);
    this.emailError = element.querySelector(emailErrorHook);

    this.init();
  }

  init() {
    this.inputs.forEach(input => input.addEventListener('focus', () => {
      this.submit.disabled = false;
    }))

    this.submit.addEventListener('click', (e) => {
      e.preventDefault();

      const elements = this.form.elements;
      let values = {};

      Array.from(elements).forEach(ele => {
        values[ele.name] = ele.value;
      })

      this.handleSubmit(values)
    })
  }

  async handleSubmit(data) {
    if(this.validateEmail(data.email) || data.email == '') {
    
      let empty = []

      for (const key in data) {
        if (data[key] == '') empty.push(key)
      }

      if (empty.length > 0) {
        this.setErrors(empty)
      } else {

        await fetch(api, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
          .then(
            this.handleSucces()
          );
        }
      } else {
        this.setEmailError()
      }

    }

  setErrors(fields) {
    this.inputs.forEach(input => {
      input.parentNode.classList[fields.includes(input.name) ? 'add' : 'remove']('contact__element--error')
    })
  }

  handleSucces() {
    this.form.style.height = `${this.form.scrollHeight}px`;
    this.title.innerHTML = 'Bedankt!'
    this.description.innerHTML = 'Wij hebben uw bericht in goede orde ontvangen.'
    this.inner.remove();
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  setEmailError() {
    this.emailError.innerHTML = 'Geef een geld e-mailadres op.'
    this.emailError.parentNode.classList.add('contact__element--error')
  }
}

export default Contact;
